module.exports = __webpack_public_path__ + "img/MONO.ab70aa2b.png";